import {AdvancedAnalysisFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';

export const ADVANCED_ANALYSIS_ACCESS_MESSAGE =
  'To access this feature, please contact your account manager or support@benchling.com.';

export function isRegressionsEnabled(): boolean {
  return isFeatureEnabled({feature: AdvancedAnalysisFeature.ADVANCED_ANALYSIS_CREATE_STATISTICS});
}

export function isAnalysisTemplatesEnabled(): boolean {
  return isFeatureEnabled({feature: AdvancedAnalysisFeature.ADVANCED_ANALYSIS_CREATE_TEMPLATES});
}

export function isAnalysisToolRedesignEnabled(): boolean {
  // Include ENABLE_ANALYSIS_TOOL_LAYOUTS_AND_VIEWS_REDESIGN so we can turn off this feature if we need to without
  // having to make a code change to remove it from insights labs.
  // Having a separate function for just this feature also makes it easier to remove it from insights labs when
  // we want to GA it.
  return (
    BenchlingConfig.ENABLE_ANALYSIS_TOOL_LAYOUTS_AND_VIEWS_REDESIGN && BenchlingConfig.ENABLE_INSIGHTS_LABS
  );
}
